import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.184 4.457v2.54h10.904v-2.54zM4.768 3a1.04 1.04 0 0 0-1.04 1.04v3.374c0 .574.465 1.04 1.04 1.04h11.736a1.04 1.04 0 0 0 1.04-1.04V4.04A1.04 1.04 0 0 0 16.505 3zM3 10.272c0-.402.326-.728.728-.728h9.5a.728.728 0 1 1 0 1.457h-9.5A.73.73 0 0 1 3 10.272m2.591 10c0-.403.326-.729.728-.729h11.227a.728.728 0 1 1 0 1.457H6.319a.73.73 0 0 1-.728-.728m3.048-5.816v2.541h10.904v-2.54zM8.223 13a1.04 1.04 0 0 0-1.04 1.04v3.374c0 .575.465 1.04 1.04 1.04h11.736a1.04 1.04 0 0 0 1.04-1.04V14.04A1.04 1.04 0 0 0 19.96 13z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=BaselineIcon24.js.map